export default __webpack_public_path__ + "static/rest-assured-9d8d24aae258a78831494826025c0673.svg";